






































import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";

@Component
export default class TdLogo extends Vue {

	@Prop({type: String, default: 'white'})
	public shapeColor!: string;

	@Prop({type: String, default: 'black'})
	public textColor!: string;

}
